import { UserLoginInfoDto } from '../../api/session';
import { IErrorInfo, IHasErrorInfo } from '@shesha-io/reactjs';
import { createAction } from 'redux-actions';

export enum AuthActionEnums {
    CheckAuthAction = 'CHECK_AUTH_ACTION',
    SetToken = 'SET_TOKEN',
    LoginUserRequest = 'LOGIN_USER_REQUEST',
    LoginUserSuccess = 'LOGIN_USER_SUCCESS',
    LoginUserError = 'LOGIN_USER_ERROR',
    LogoutUser = 'LOGOUT_USER',
    FetchedUserDataAsyncRequest = 'FETCHED_USER_DATA_ASYNC_REQUEST',
    FetchUserDataRequest = 'FETCH_USER_DATA_REQUEST',
    FetchUserDataSuccess = 'FETCH_USER_DATA_SUCCESS',
    FetchUserDataError = 'FETCH_USER_DATA_ERROR',
    SetIsLoggedIn = 'SET_IS_LOGGED_IN',
    VerifyOtpSuccess = 'VERIFY_OTP_SUCCESS',
    ResetPasswordSuccess = 'RESET_PASSWORD_SUCCESS',
}

export const fetchUserDataAction = createAction(AuthActionEnums.FetchUserDataRequest);

export const fetchedUserDataAsyncAction = createAction(AuthActionEnums.FetchedUserDataAsyncRequest);

export const fetchUserDataActionSuccessAction = createAction<UserLoginInfoDto, UserLoginInfoDto>(
  AuthActionEnums.FetchUserDataSuccess,
  (p) => p
);

export const setIsLoggedInAction = createAction<boolean, boolean>(AuthActionEnums.SetIsLoggedIn, (p) => p);

export const fetchUserDataActionErrorAction = createAction<IHasErrorInfo, IErrorInfo>(
  AuthActionEnums.FetchUserDataError,
  (p) => ({ errorInfo: p })
);

export const setAccessTokenAction = createAction<string, string>(AuthActionEnums.SetToken, (p) => p);